// Requires: src/namespace.js
// Requires: lib/caret.js

window.BOL.Checkout.State = (function(Caret) {
	'use strict';

	return new Caret({
		promotion:		{},
		summary:		{},
		promoAlert:		{},
		currentAddress:	{},
		currentAddressBilling:	{},
		addressSelect:	{}
	});

})(window.BOL.Caret);
